import type { MarketItem } from '@/types';

function object(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};
}
export function marketManifest(item: MarketItem): Record<string, unknown> {
  try {
    return object(
      JSON.parse(
        (item.activeRelease ?? item.latestAvailableRelease)?.manifestJson ??
          '{}',
      ),
    );
  } catch {
    return {};
  }
}
function text(value: unknown, locale: string): string {
  if (typeof value === 'string') return value;
  const localized = object(value);
  const selected = localized[locale] ?? localized['en-US'];
  return typeof selected === 'string' ? selected : '';
}
export function marketItemDisplay(item: MarketItem, locale = 'zh-CN') {
  const display = object(marketManifest(item).display);
  let iconUrl = '';
  if (typeof display.iconUrl === 'string') {
    try {
      const parsed = new URL(display.iconUrl);
      if (
        !parsed.username &&
        !parsed.password &&
        (parsed.protocol === 'https:' ||
          (item.itemType === 'connector' && parsed.protocol === 'http:'))
      )
        iconUrl = display.iconUrl;
    } catch {
      /* Invalid published metadata remains readable using the item key. */
    }
  }
  return {
    name: text(display.name, locale).trim() || item.itemKey,
    description: text(display.description, locale),
    iconUrl,
  };
}
export function skillManifestSummary(item: MarketItem) {
  const payload = object(marketManifest(item).payload);
  const compatibility = object(payload.compatibility);
  return {
    entrypoint:
      typeof payload.entrypoint === 'string' ? payload.entrypoint : '—',
    minimumHostVersion:
      typeof compatibility.minimumHostVersion === 'string'
        ? compatibility.minimumHostVersion
        : '—',
    agentProviders: Array.isArray(compatibility.agentProviders)
      ? compatibility.agentProviders.filter(
          (value): value is string => typeof value === 'string',
        )
      : [],
  };
}
export function skillNeedsVersionSelection(item: MarketItem): boolean {
  return !item.activeVersion || item.activeRelease?.status !== 'available';
}

export function skillListingCandidates(
  items: readonly MarketItem[],
): MarketItem[] {
  return items.filter(
    (item) =>
      item.itemType === 'skill' &&
      (item.activeRelease?.status === 'available' ||
        item.latestAvailableRelease?.status === 'available') &&
      ['domestic', 'overseas'].some(
        (market) =>
          !item.listings.some(
            (listing) => listing.marketType === market && listing.isListed,
          ),
      ),
  );
}
